import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { AppStrings } from "../../utils/constants/AppStrings";
import { getApiErrorMessage } from "../../utils/ErrorUtils";
import { bonusAdminEnvelope } from "./bonusAdminBody";
import { LIST_SEGMENTS_QUERY_KEY } from "./useListSegments";

import type { SegmentIn, SegmentOut } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

type CreateSegmentResult = { body: SegmentOut; message?: string };

async function postSegment(payload: SegmentIn): Promise<CreateSegmentResult> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const response = await instance.post(
    API_ROUTES.CREATE_DYNAMIC_BONUS_SEGMENT,
    payload,
  );
  const envelope = bonusAdminEnvelope<SegmentOut>(response);
  if (!envelope.body) {
    throw new Error("Segment creation returned no data");
  }
  return { body: envelope.body, message: envelope.message };
}

export const useCreateSegment = () => {
  const queryClient = useQueryClient();

  return useMutation<CreateSegmentResult, Error, SegmentIn>({
    mutationFn: postSegment,
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: LIST_SEGMENTS_QUERY_KEY });
      message.success(result.message || AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED);
    },
    onError: (error) => {
      message.error(getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED));
    },
  });
};
